var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridZip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.88,
    height: 37.85,
    viewBox: "0 0 29.88 37.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76335",
    "data-name": "Group 76335",
    transform: "translate(-904 -643.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62926",
    "data-name": "Path 62926",
    d: "M312.339,414.89v23.223a1.992,1.992,0,0,1-1.992,1.992h-25.9a1.993,1.993,0,0,1-1.992-1.992V404.249a1.992,1.992,0,0,1,1.992-1.992h15.256a4.048,4.048,0,0,1,2.863,1.185l8.585,8.585A4.049,4.049,0,0,1,312.339,414.89Z",
    transform: "translate(621.541 241.742)",
    fill: "#d9ebfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_39",
    "data-name": "Union 39",
    d: "M3,29.739H.178a.963.963,0,0,1,.867-.6h1.1a.96.96,0,0,1,.865.6l0,0Zm.851-.6a1.049,1.049,0,0,1,0-2.088H4.951a1.048,1.048,0,0,1,0,2.088ZM1.045,27.067a1.048,1.048,0,0,1,0-2.088h1.1a1.048,1.048,0,0,1,0,2.088Zm2.811-2.088a1.049,1.049,0,0,1,0-2.089H4.951a1.048,1.048,0,0,1,0,2.089ZM1.045,22.905a1.046,1.046,0,0,1,0-2.085h1.1a1.046,1.046,0,0,1,0,2.085ZM3.856,20.82a1.049,1.049,0,0,1,0-2.088H4.951a1.048,1.048,0,0,1,0,2.088ZM1.045,18.745a1.048,1.048,0,0,1,0-2.088h1.1a1.048,1.048,0,0,1,0,2.088Zm2.811-2.088a1.049,1.049,0,0,1,0-2.088H4.951a1.048,1.048,0,0,1,0,2.088ZM1.045,14.584a1.049,1.049,0,0,1,0-2.089h1.1a1.049,1.049,0,0,1,0,2.089ZM3.856,12.5a1.047,1.047,0,0,1,0-2.085H4.951a1.046,1.046,0,0,1,0,2.085ZM1.91,9.417A2,2,0,0,1,0,7.332V1.269A1.22,1.22,0,0,1,1.162,0H4.837A1.219,1.219,0,0,1,6,1.269V7.332a2,2,0,0,1-1.91,2.085Zm.258-6.889v.953a.515.515,0,0,0,.491.535h.68a.514.514,0,0,0,.491-.535V2.528a.313.313,0,0,0-.3-.325H2.467A.313.313,0,0,0,2.168,2.528Z",
    transform: "translate(912.11 652.11)",
    fill: "#439cf3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridZip);
export default __webpack_public_path__ + "static/media/grid_zip.ac748179970db47b7a5aaa8df7d2ee1a.svg";
export { ForwardRef as ReactComponent };